import Barba from 'barba.js'
import Cisco from './../classes/Cisco'
import Connection from './../classes/Cisco/Connection'
import axios from 'axios'

export default Barba.BaseView.extend({
    namespace: 'cisco',
    agents: {
        marco_z: 'marco.zancan@delbrenta.com',
        claudio: 'claudio.gottardo@delbrenta.com',
        marco_g: 'marco.gobbi@delbrenta.com',
        sergio: 'sergio.madruzza@delbrenta.com',
        stefano_z: 'stefano.zagari@delbrenta.com',
        emanuele: 'emanuele.delorenzi@delbrenta.com',
        luciano: 'luciano.polato@delbrenta.com',
        giulia: 'giulia.bagnolini@delbrenta.com',
        stefano_b: 'stefano.bezzon@delbrenta.com',
    },
    buttons: [],
    async onEnter() {
        if( ! Barba.cisco ) Barba.cisco = new Cisco;

        Barba.cisco.buttonListeners();

        this.buttons = document.querySelectorAll('.cisco-buttons');
        this.buttons.forEach( el => el.querySelector('.status-indicator').classList.add('loading') )

        for( let key in this.agents ) {
            Barba.cisco.getConnection().spark.people.list({email: this.agents[key] } )
                .then( person => {
                    document.querySelector('#cisco-'+key+' .status-indicator').classList.remove('loading' );
                    document.querySelector('#cisco-'+key+' .status-indicator').classList.add( person.items[0].status )
                } )
        }
    },
    onEnterCompleted() {
    },
    onLeave() {
        this.buttons.forEach( el => el.querySelector('.status-indicator').className = 'status-indicator' )
    },
    onLeaveCompleted() {
    }
})